var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useStore } from "effector-react";
import { $playerCurrentTrackId, $playerCurrentTrackSource } from "./model";
import { $isAudioLoading, $isAudioPlaying, useIsAudioLoading, useIsAudioPlaying, } from "../audio";
export var usePlayerTrackId = function () { return useStore($playerCurrentTrackId); };
export var usePlayer = function () {
    var playing = useIsAudioPlaying();
    var loading = useIsAudioLoading();
    var source = useStore($playerCurrentTrackSource);
    var currentTrackId = useStore($playerCurrentTrackId);
    if (!source) {
        return null;
    }
    return { audio: { loading: loading, playing: playing }, source: source, track: { id: currentTrackId } };
};
export var useCurrentPlaylistTrackSource = function () {
    var source = useStore($playerCurrentTrackSource);
    var playing = useStore($isAudioPlaying);
    var loading = useStore($isAudioLoading);
    if (!source || source.type !== "playlist") {
        return null;
    }
    return __assign(__assign({}, source), { playing: playing, loading: loading });
};
export var useIsPlaylistSelectedForPlayer = function (id) {
    var playerCurrentTrackSource = useStore($playerCurrentTrackSource);
    return !!(playerCurrentTrackSource &&
        playerCurrentTrackSource.type === "playlist" &&
        playerCurrentTrackSource.attributes.id === id);
};
export var useIsSearchedTrackSelectedForPlayer = function (trackId) {
    var playerCurrentTrackSource = useStore($playerCurrentTrackSource);
    var playerCurrentTrackId = useStore($playerCurrentTrackId);
    return ((playerCurrentTrackSource === null || playerCurrentTrackSource === void 0 ? void 0 : playerCurrentTrackSource.type) === "search_result" &&
        playerCurrentTrackId === trackId);
};
export var useIsUserFileSelectedForPlayer = function (trackId) {
    var playerCurrentTrackSource = useStore($playerCurrentTrackSource);
    var playerCurrentTrackId = useStore($playerCurrentTrackId);
    return ((playerCurrentTrackSource === null || playerCurrentTrackSource === void 0 ? void 0 : playerCurrentTrackSource.type) === "user_advertisement_files" &&
        playerCurrentTrackId === trackId);
};
export var useIsPlaylistTrackSelectedForPlayer = function (trackId) {
    var playerCurrentTrackSource = useStore($playerCurrentTrackSource);
    var playerCurrentTrackId = useStore($playerCurrentTrackId);
    return ((playerCurrentTrackSource === null || playerCurrentTrackSource === void 0 ? void 0 : playerCurrentTrackSource.type) === "playlist" &&
        playerCurrentTrackId === trackId);
};
export var useIsTimetableSelectedForPlayer = function (timetableId) {
    var playerCurrentTrackSource = useStore($playerCurrentTrackSource);
    return ((playerCurrentTrackSource === null || playerCurrentTrackSource === void 0 ? void 0 : playerCurrentTrackSource.type) === "today_timetable" &&
        (playerCurrentTrackSource === null || playerCurrentTrackSource === void 0 ? void 0 : playerCurrentTrackSource.attributes.id) === timetableId);
};
